// Returns correct `relatedTarget` and `currentTarget` for every browser, including IE11
import { isClient, isIE } from './accessibility';
export var getEventTargets = function getEventTargets(e) {
  var relatedTarget = e.relatedTarget;
  var currentTarget = e.currentTarget;

  if (!relatedTarget && isClient() && isIE()) {
    relatedTarget = document.activeElement;
  }

  return {
    relatedTarget: relatedTarget,
    currentTarget: currentTarget
  };
}; // Checks if blur event happened in same target

export var focusInCurrentTarget = function focusInCurrentTarget(e, excludedRef) {
  var _getEventTargets = getEventTargets(e),
      relatedTarget = _getEventTargets.relatedTarget,
      currentTarget = _getEventTargets.currentTarget;

  if (excludedRef && excludedRef.current && excludedRef.current.contains(relatedTarget)) {
    return true;
  }

  if (relatedTarget === null) {
    return false;
  }

  var node = relatedTarget.parentNode;

  while (node !== null) {
    if (node === currentTarget) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
};